/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Date/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Date({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/InstallmentDates/SelectedInstallmentInterval/Dates/Date"
  
}) {
let newPaymentPlanInstallmentDateValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan_installment_date',
})
let newPaymentPlanSelectedInstallmentDateValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'selected_installment_date',
})
let newPaymentPlanInstallmentDateItemIndexValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan_installment_date_item',
path: 'index',
})
let aggregateData = fromHelpers.getSelectedValue(newPaymentPlanSelectedInstallmentDateValueData, newPaymentPlanInstallmentDateItemIndexValueData)
let newPaymentPlanInstallmentDateItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan_installment_date_item',
path: 'isFirst',
})
let newPaymentPlanInstallmentDateItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan_installment_date_item',
path: 'isLast',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={dtSpaceXs}
 marginLeft={newPaymentPlanInstallmentDateItemIsFirstValueData ? "0px" : dtSpaceXs}
 marginRight={newPaymentPlanInstallmentDateItemIsLastValueData ? "0px" : dtSpaceXs}
 allowEmptyChoice={false}
 data={newPaymentPlanInstallmentDateItemIsFirstValueData ? "new_payment_plan_installment_date_item.isLast" : "new_payment_plan_installment_date"}
 from={newPaymentPlanInstallmentDateValueData}
 data={newPaymentPlanInstallmentDateItemIsFirstValueData ? "new_payment_plan_installment_date_item.isLast" : "new_payment_plan.selected_installment_date"}
 data={newPaymentPlanInstallmentDateItemIsFirstValueData ? "new_payment_plan_installment_date_item.isLast" : "new_payment_plan_installment_date_item.index"}
 aggregate="helpers.js getSelectedValue"
 value={aggregateData}
 onChange={onChange}
 data={newPaymentPlanInstallmentDateItemIsFirstValueData ? "new_payment_plan_installment_date_item.isLast" : "new_payment_plan_installment_date_item.isFirst"}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 backgroundColor="white"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}